export const PAGE = {
  COTTO: '100207768987988',
  TRUEIDTEST: '109674367070653',
  TRUEID: '1858940081055826',
  YASALE: '100701258941039',
  THAILANDPOSTMARTTEST: '115414076948160',
  POWERBUY_MAIN_PAGE: '105046831863695',
  POWERBUY_SHOP_SERVICES: [
    'L1656221467',
    'L1656909148',
    '301460564518350',
    '106229284674746',
    '105344925152387'
  ],
  DENTAL_HUB_TEST: '107442612088753',
  DENTAL_HUB: '103085964619116'
}



// WEBPACK FOOTER //
// ./src/constants/page.js